export default __webpack_public_path__ + "static/logo8-b866bd8290ada86feacd270233c62a3f.png";